import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "@store/index";

const selectBookingCalendarState = (state: RootState) => state.bookingCalendar;

export const selectCalendarEvents = createSelector(
  [selectBookingCalendarState],
  bookingCalendarState => bookingCalendarState.calendarEvents
);

export const selectTempEvents = createSelector(
  [selectBookingCalendarState],
  bookingCalendarState => bookingCalendarState.tempEvents
);

export const selectAllCalendarEvents = createSelector(
  [selectCalendarEvents, selectTempEvents],
  (calendarEvents, tempEvents) => [...calendarEvents, ...tempEvents]
);

export const selectEventsByType = createSelector(
  [selectCalendarEvents, (_state: RootState, eventType: string) => eventType],
  (events, eventType) => events.filter(event => event.type === eventType)
);

export const selectEventsByResource = createSelector(
  [selectCalendarEvents, (_state: RootState, resourceId: string) => resourceId],
  (events, resourceId) =>
    events.filter(event => event.resourceId === resourceId)
);
